import {AfterViewInit, Directive, ElementRef, OnInit} from '@angular/core';
import {Guid} from '../models/Guid';

@Directive({
  selector: 'input',
})
export class InputDisableAutocompleteDirective implements OnInit {
  constructor(private el: ElementRef) {
  }

  ngOnInit(): void {
    const input: HTMLInputElement = this.el.nativeElement as HTMLInputElement;
    if (!input.getAttribute('autocomplete')) {
      const random = Math.random().toString(36).substring(7);
      input.setAttribute('autocomplete', random);
      input.setAttribute('name', random);
    }
  }
}
